export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#1E3A5F] text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-20 mb-12">
          {/* Company Logo and Name */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg p-1">
                <img 
                  src="https://static.readdy.ai/image/0a78d90c9152fb6c1f8f3ab95c0bdb39/388e785e7df1ce97cb4d2ec85e67fec7.png" 
                  alt="Build to Lead Icon" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold text-white">Build to Lead</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              UK-focused lead generation and enquiry automation for house extension and loft conversion companies.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('what-we-do')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  What We Do
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  Why Us
                </button>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Get in Touch */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold text-white">Get in Touch</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-[#4A6FA5] flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-300 text-sm">Phone</p>
                  <a href="tel:02045722610" className="text-white hover:text-gray-200 transition-colors cursor-pointer">
                    020 4572 2610
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-[#4A6FA5] flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-300 text-sm">Email</p>
                  <a href="mailto:hello@buildtolead.co.uk" className="text-white hover:text-gray-200 transition-colors cursor-pointer">
                    hello@buildtolead.co.uk
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-[#4A6FA5] flex-shrink-0 mt-1"></i>
                <div>
                  <p className="text-gray-300 text-sm">Location</p>
                  <p className="text-white">United Kingdom</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Build to Lead. All rights reserved.
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-gray-300 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
